import * as Sentry from '@sentry/nextjs';
import { GlueApiError } from '@/src/lib/http/business/http-error';

const nonSentryErrorCodes = ['002'];

export function logToSentry(error: Error | unknown, message?: string) {
  if (!Sentry.isInitialized() || !exceptionShouldBeSentToSentry(error)) {
    return;
  }

  if (message) {
    captureMessage(message);
  }

  captureException(error);
}

function captureMessage(message: string) {
  Sentry.captureMessage(message);
}

function captureException(error: Error | unknown) {
  Sentry.captureException(error);
}

function exceptionShouldBeSentToSentry(error: Error | GlueApiError | unknown): boolean {
  if (error instanceof GlueApiError) {
    return !nonSentryErrorCodes.includes(error.errors[0].code);
  }

  return true;
}
